import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { LOGIN_FORM_BG_COLOR, LOGIN_TEXT_COLOR } = constants;

let styles = {
  logo: {
    width: 200,
    margin: 30
  },
  form: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'center',
    width: 470,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    borderRadius: 5,
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    padding: '20px 50px'
  },
  forgot: {
    alignSelf: 'flex-end',
    fontSize: '0.9em',
    textDecoration: 'none',
    color: LOGIN_TEXT_COLOR
  },
  actions: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-around',
    padding: '85px 50px 30px',
    width: '100%'
  },
  actionsError: {
    paddingTop: 35
  },
  create: {
    marginLeft: 10,
    backgroundColor: `${LOGIN_FORM_BG_COLOR} !important`
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/loginform/LoginForm.styles.js